module.exports = "https://milano-network.servercdn.it/static/img/docs.jpg?6991badcb53d0023c21499714851e5dd";